import { render, staticRenderFns } from "./CreateOrderWizard.vue?vue&type=template&id=638ebd24&"
import script from "./CreateOrderWizard.vue?vue&type=script&lang=js&"
export * from "./CreateOrderWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports